module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_06_game.9d1f30b9.png";